module.exports = __webpack_public_path__ + "static/media/minus.5552bbb5.svg";